import { SET_IS_FORM_DIRTY } from "../../types/common/form";

export const setIsformDirty = (isFormDirty) => {
  return {
    type: SET_IS_FORM_DIRTY,
    payload: { isFormDirty },
  };
};
